export const HomePageRedirect = () => {
  window.location.replace('https://www.nodal.com/');
  return null;
};
